import './styles.scss';

export { default as QuickSearch } from './QuickSearch';
